import { Dialog } from "primereact/dialog"
import { PlanoType } from "../../db/Orm"
import { DocumentoAntecipacao } from "../components/DocumentoAntecipacao"
import { useEffect, useRef, useState } from "react"
import { GeracaoDocumento } from "../components/GeracaoDocumento"
import { Toast } from "primereact/toast"

export type TermoFields = 'termo'|'termo_assinado_aiba'|'termo_assinado_produtor'|'termo_assinado_adab'
const DIALOG_HEADERS: Record<TermoFields, string> = {
    termo: 'Termo',
    termo_assinado_aiba: 'Termo - Assinatura AIBA',
    termo_assinado_produtor: 'Termo - Assinatura do Produtor',
    termo_assinado_adab: 'Termo - Assinatura ADAB'
}
type LoadedTermosType = Record<TermoFields, null|{url: string, file:File}>

type TermoAntecipacaoProps = {
    visible: boolean
    hide: ()=>void
    antecipacao: PlanoType
    carregarPlanos: ()=>Promise<void>|(()=>void)
    termoField: TermoFields
}
export const DialogTermoAntecipacao = (props: TermoAntecipacaoProps)=>{
    const [initialFile, setInitialFile] = useState<File|null|undefined>(props.antecipacao[props.termoField] ? undefined : null)
    useEffect(()=>{
        setInitialFile(props.antecipacao[props.termoField] ? undefined : null)
    }, [props.antecipacao[props.termoField]])
    const loadedTermos = useRef<LoadedTermosType>({termo: null, termo_assinado_aiba: null, termo_assinado_produtor: null, termo_assinado_adab: null})
    const toast = useRef<Toast>(null)
    return <Dialog header={DIALOG_HEADERS[props.termoField]} visible={props.visible} onHide={props.hide} >
        <Toast ref={toast} position='center' />
        {props.termoField==='termo' && !props.antecipacao.termo && <GeracaoDocumento antecipacao={props.antecipacao} documento='termo'
        toastRef={toast} carregarPlanos={props.carregarPlanos} />}
        {props.antecipacao.termo && <DocumentoAntecipacao antecipacao={props.antecipacao} carregarPlanos={props.carregarPlanos}
            documentoField={props.termoField} tipoDocumento="Termo" initialFile={initialFile} setInitialFile={setInitialFile}
            loadedFiles={loadedTermos.current} permitirEnvio={props.termoField !== 'termo'} toastRef={toast} />}
    </Dialog>
}